exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table {\n  table-layout: fixed; }\n\nh2 {\n  margin: 0; }\n\n.totals td {\n  font-weight: bold; }\n\n.gr-check th {\n  background: #f5dbd9; }\n\n.gr-check.bal th {\n  background: #c6e4ab; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/app/views/reports/summary/summary.component.scss
// module id = ../../../../../src/app/views/reports/summary/summary.component.scss
// module chunks = main